<template>
  <v-dialog v-model="showDeleteProcessDialog" max-width="390">
    <v-card v-if="prepared === true">
      <span style="float:right" class="ma-4">
        <v-icon v-on:click="discard()">clear</v-icon>
      </span>
      <v-card-title>
        <span class="body-2">Sind Sie absolut sicher?</span>
      </v-card-title>
      <v-card-text>
        <p>
          Alle mit Verfahren Nr. {{ deleteManager.root.seq_nr }} "{{ deleteManager.root.text_header }}" verknüpften
          Daten werden unwiderbringlich gelöscht.
        </p>
        <ul class="mb-4">
          <li v-for="item in deleteManager.deleteLists.slice().reverse()" v-if="item.entities.length > 0">
            {{ item.entities.length }} {{ item.label }}
          </li>
        </ul>
        <p>
          Diese Maßnahme ist in der Regel nicht revisionssicher. Möchten Sie wirklich fortfahren?
        </p>
      </v-card-text>
      <div class="text-center">
        <v-card-actions>
          <v-btn color="error" v-on:click="onClickDelete()">Verfahren Löschen</v-btn>
        </v-card-actions>
      </div>
    </v-card>
    <v-card v-if="deleting === true">
      <v-card-title>
        <span class="body-2">Löschvorgang</span>
      </v-card-title>
      <v-card-text>
        <v-progress-linear v-model="entitiesDeletedRatio"></v-progress-linear>
        <p>{{ numberNextEntitiesAlreadyDeleted }}/{{ numberNextEntitiesToBeDeleted }} {{ currentlyDeletingEntity }}</p>
      </v-card-text>
    </v-card>
    <v-card v-if="deleteDone == true">
      <v-card-title>
        <span class="body-2">Löschen erfolgreich</span>
      </v-card-title>
      <v-card-text>
        <span><v-icon color="success">check</v-icon></span>
        <span>Verfahren wurde gelöscht.</span>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { SodaDeleteManager } from "../util/DeleteManager";

export default {
  name: "ProcessDeleteView",
  props: {
    process_id: String,
    showThis: Boolean,
  },
  computed: {
    entitiesDeletedRatio() {
      return (100.0 * this.totalNumberEntitiesAlreadyDeleted) / this.totalNumberEntitiesToBeDeleted;
    },
    prepared() {
      return this.deleteManager && this.deleteManager.state === "prepared";
    },
    deleting() {
      return this.deleteManager && this.deleteManager.state === "deleting";
    },
    deleteDone() {
      return this.deleteManager && this.deleteManager.state === "done";
    },
  },
  watch: {
    showThis: function(st) {
      this.showDeleteProcessDialog = st;
      if (st) {
        this.init();
      }
    },
    showDeleteProcessDialog: function(show) {
      if (show === false) {
        this.$emit("discard");
      }
    },
  },
  methods: {
    init() {
      this.deleteManager = new SodaDeleteManager("Process", this.deletePlanned, this.updateCounts, this.deleteDoneCB);
      this.deleteManager.prepare(this.process_id);
    },
    onClickDelete() {
      this.$eventHub.emit("sync-status-syncing");
      this.deleteManager.delete();
    },
    deletePlanned(deleteLists) {
      //console.log('deletePlanned',deleteLists)
    },
    updateCounts(counts) {
      this.total_count = counts.total_count;
      this.deleted_count = counts.deleted_count;
      this.currentlyDeletingEntity = counts.deleting_entity;
      this.numberNextEntitiesToBeDeleted = counts.total_count_detail;
      this.numberNextEntitiesAlreadyDeleted = counts.deleted_count_detail;
    },
    deleteDoneCB(result) {
      var process = this.deleteManager.root;
      if (result.success) {
        this.$eventHub.emit("sync-status-success", {
          entity_type: "Verfahren",
          entity_label: process.text_header,
          sync_type: "delete",
        });
      } else {
        this.$eventHub.emit("sync-status-failure", {
          entity_type: "Verfahren",
          entity_label: process.text_header,
          sync_type: "delete",
          error: result.error,
        });
      }
      setTimeout(() => {
        this.$emit("didDelete");
        this.showDeleteProcessDialog = false;
      }, 1000);
    },
    discard() {
      this.showDeleteProcessDialog = false;
    },
  },
  data: () => ({
    showDeleteProcessDialog: false,
    //deleting: false,
    total_count: 0,
    deleted_count: 0,
    numberNextEntitiesAlreadyDeleted: 0,
    numberNextEntitiesToBeDeleted: 0,
    currentlyDeletingEntity: null,
    deleteManager: null,
  }),
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped></style>
